import React from 'react';

import searchbarBg from '@assets/images/searchbar-bg.png';
import SearchBarVariant from '@components/common/SearchBarVariant';
import { CDN_URL, getCdnImageUrl } from '@utils/cloudflare';

import ImageLoaded from '@components/common/ImageLoaded/ImageLoaded';

type SearchbarSectionProps = {
  background: string;
  applyFilters: string[];
};

export default function SearchbarSection({ background, applyFilters }: SearchbarSectionProps) {
  const searchbarBackground = background ? getCdnImageUrl(720, background, CDN_URL) : searchbarBg;
  return (
    <div
      id="searchbar-section"
      className="relative h-304 flex items-center justify-center border-b border-rp-primary-redesign d:h-200"
    >
      <h1 className="text-base top-11 text-rp-neutral z-10 absolute d:text-xl">
        Find your next daycation
      </h1>
      <ImageLoaded
        url={searchbarBackground}
        classes="absolute w-full h-full"
        layout="fill"
        objectFit="cover"
        alt="searchbar background"
      />
      <SearchBarVariant newDesign applyFilters={applyFilters} />
    </div>
  );
}
